
import React from "react";
import CampAdminEditor from "./CampAdminEditor";

const AdminCampsManager: React.FC = () => {
  return <CampAdminEditor />;
};

export default AdminCampsManager;
